import { Box } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import { useScreenContainerContext } from '../../flow/screen-container/screen-container-provider';

export const InfomarkerIcon = () => {
  const { setIsNerdyInsightModalOpen } = useScreenContainerContext();
  return (
    <Box sx={{ display: 'inline', whiteSpace: 'nowrap' }}>
      &nbsp;
      <Box
        sx={(theme) => ({
          cursor: 'pointer',
          [theme.breakpoints.down('sm')]: {
            verticalAlign: 'top',
            marginTop: '2px',
          },
          display: 'inline-block',
        })}
      >
        <InfoOutlined onClick={() => setIsNerdyInsightModalOpen(true)} />
      </Box>
    </Box>
  );
};
